import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';


@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
    providers: [
        ListService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersComponent {

  constructor(
  ) { }

}
